import LoanApplicationModal from "../../shared/LoanApplicationModal";

const Finish = ({
  closeFinish,
  activeIndex,
  handleNextStep,
  finishText,
  loading,
}) => {
  return (
    <LoanApplicationModal
      closeBioInformation={closeFinish}
      activeIndex={activeIndex}
      handleNextStep={handleNextStep}
      finishText={finishText}
      loading={loading}
    >
      <p className="text-[#000000] font-normal text-[14px]">
        Create a New Loan Application
      </p>
      <p className="text-[#000000] font-semibold text-[20px]">
        Send Documents & Finish
      </p>
      <p className="text-[#5C5C5C] text-[14px] font-normal">
        By pressing finish respective legal document pertaining to the loan will
        be sent to the Borrower and Guarantor(s). This can be done only if the
        application is complete.
      </p>

      {/* Borrower Section */}
      <div className="h-[40px] px-[10px] bg-[#F3F3F3] my-[20px] w-full flex items-center">
        <p className="text-[#000000] text-[14px] font-normal">
          Items & Documents to be Sent To Borrower
        </p>
      </div>
      <p className="text-[#5C5C5C] font-normal text-[14px] mb-[10px]">
        <a
          href="https://helacred.anansitechnology.com/dashboard/terms-conditions"
          target="_blank"
          rel="noreferrer"
          className="text-[#000000] underline cursor-pointer"
        >
          The Loan Terms
        </a>{" "}
        – Including repayment obligations and conditions.
      </p>
      <p className="text-[#5C5C5C] font-normal text-[14px] mb-[10px]">
        <a
          href="https://helacred.anansitechnology.com/dashboard/terms-conditions"
          target="_blank"
          rel="noreferrer"
          className="text-[#000000] underline cursor-pointer"
        >
          The Terms & Conditions
        </a>{" "}
        of Helacred – Governing the loan agreement.
      </p>
      <p className="text-[#5C5C5C] font-normal text-[14px] mb-[10px]">
        <a
          href="https://helacred.anansitechnology.com/dashboard/privacy-policy"
          target="_blank"
          rel="noreferrer"
          className="text-[#000000] underline cursor-pointer"
        >
          The Data Protection Act
        </a>{" "}
        – Ensuring the lawful use of your personal information.
      </p>
      <p className="text-[#5C5C5C] font-normal text-[14px] mb-[10px]">
        <a
          href="https://helacred.anansitechnology.com/dashboard/loan-affidavit"
          target="_blank"
          rel="noreferrer"
          className="text-[#000000] underline cursor-pointer"
        >
          The Affidavit
        </a>{" "}
        – Affirming that all information provided is true and accurate.
      </p>

      {/* Guarantor Section */}
      <div className="h-[40px] px-[10px] bg-[#F3F3F3] my-[20px] w-full flex items-center">
        <p className="text-[#000000] text-[14px] font-normal">
          Items & Documents to be Sent To Guarantor(s)
        </p>
      </div>
      <p className="text-[#5C5C5C] font-normal text-[14px] mb-[10px]">
        <a
          href="https://helacred.anansitechnology.com/dashboard/terms-conditions"
          target="_blank"
          rel="noreferrer"
          className="text-[#000000] underline cursor-pointer"
        >
          Borrower’s Loan Terms
        </a>{" "}
        – Including repayment obligations and conditions.
      </p>
      <p className="text-[#5C5C5C] font-normal text-[14px] mb-[10px]">
        <a
          href="https://helacred.anansitechnology.com/dashboard/terms-conditions"
          target="_blank"
          rel="noreferrer"
          className="text-[#000000] underline cursor-pointer"
        >
          The Terms & Conditions
        </a>{" "}
        of Helacred – Governing the loan agreement.
      </p>
      <p className="text-[#5C5C5C] font-normal text-[14px] mb-[10px]">
        <a
          href="https://helacred.anansitechnology.com/dashboard/privacy-policy"
          target="_blank"
          rel="noreferrer"
          className="text-[#000000] underline cursor-pointer"
        >
          The Data Protection Act
        </a>{" "}
        – Ensuring the lawful use of your personal information.
      </p>
    </LoanApplicationModal>
  );
};

export default Finish;
